import { PersonHelper, RouteHelper } from '@/helpers/'
import { ROUTE_INDEX_SIGNATURE_ENTRY, ROUTE_INDEX_SIGNATURE_VERIFICATION } from '@/config/constants'

export default [
  {
    beforeEnter: (to, _from, next) => {
      const basket = RouteHelper.getBasket()
      if (!basket.signature || !basket.signature.signatureRequired) {
        next({ name: RouteHelper.getNextRoute(basket) })
      } else if (!to.params.personId) {
        const signees = PersonHelper.getSignees()
        next({
          name: to.name,
          params: {
            personId: signees[0].personId,
          },
        })
      } else {
        next()
      }
    },

    component: () =>
      import(/* webpackChunkName: "screen-signature" */ '@/modules/Configurator/screens/DigitalSignature/Entry'),
    meta: {
      headerDisabled: true,
      navigation: false,
      index: ROUTE_INDEX_SIGNATURE_ENTRY,
    },
    name: 'digital-signature-entry',
    path: '/digital-signature/entry/:personId?',
    props: route => ({
      personId: route.params.personId,
    }),
  },
  {
    beforeEnter: (_to, _from, next) => {
      const basket = RouteHelper.getBasket()
      if (!basket.signature || !basket.signature.signatureRequired) {
        next({ name: RouteHelper.getNextRoute(basket) })
      } else {
        next()
      }
    },

    component: () =>
      import(/* webpackChunkName: "screen-signature" */ '@/modules/Configurator/screens/DigitalSignature/Verification'),
    meta: {
      headerDisabled: true,
      navigation: false,
      index: ROUTE_INDEX_SIGNATURE_VERIFICATION,
    },
    name: 'digital-signature-verification',
    path: '/digital-signature/verification',
  },
]
